//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import angular from 'angular';

import template from './ads-menu.html';

angular.module('curalate').component('adsMenu', {
  template,
  controller: [
    'SessionVarsService',
    function (SessionVarsService) {
      this.$onInit = () => {
        this.isFacebookReview = SessionVarsService.isFacebookReview();
      };
    },
  ],
});
